import common from './common';
import home from './home';
import guide from './guide';
import test from './test';

export default { common, home, guide, test };


// WEBPACK FOOTER //
// ./src/locales/ko-KR/index.ts